/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon20Solid = forwardRef('UiMenuDots9Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.874 3.749a1.874 1.874 0 1 1-3.747 0 1.874 1.874 0 0 1 3.747 0Z" }),
        React.createElement("path", { d: "M16.251 5.627a1.874 1.874 0 1 0 0-3.747 1.874 1.874 0 0 0 0 3.747Z" }),
        React.createElement("path", { d: "M18.125 10a1.874 1.874 0 1 1-3.747 0 1.874 1.874 0 0 1 3.747 0Z" }),
        React.createElement("path", { d: "M11.874 16.249a1.874 1.874 0 1 1-3.748 0 1.874 1.874 0 0 1 3.748 0Z" }),
        React.createElement("path", { d: "M18.125 16.253a1.874 1.874 0 1 1-3.747 0 1.874 1.874 0 0 1 3.747 0Z" }),
        React.createElement("path", { d: "M3.751 18.127a1.874 1.874 0 1 0 0-3.747 1.874 1.874 0 0 0 0 3.747Z" }),
        React.createElement("path", { d: "M10 11.874a1.874 1.874 0 1 0 0-3.747 1.874 1.874 0 0 0 0 3.747Z" }),
        React.createElement("path", { d: "M5.625 10a1.874 1.874 0 1 1-3.747 0 1.874 1.874 0 0 1 3.747 0Z" }),
        React.createElement("path", { d: "M3.751 5.627a1.874 1.874 0 1 0 0-3.747 1.874 1.874 0 0 0 0 3.747Z" })));
});
